import { useChat } from '../../../../libs/hooks';
import { useAppSelector } from '../../../../redux/app/hooks';
import { ModalDialog } from '../ChatWindow/Shared/ModalDialog';
interface IEditChatNameProps {
    chatId: string;
    open: boolean;
    onClose: () => void;
}

export const DeleteChatDialog: React.FC<IEditChatNameProps> = ({ chatId, open, onClose }) => {
    const chat = useChat();

    const { conversations } = useAppSelector((state) => state.conversations);

    const onDeleteChat = () => {
        void chat.deleteChat(chatId);
    };

    return (
        <ModalDialog
            title={`Are you sure you want to delete chat: ${conversations[chatId]?.title?.substring(0, 60) + '...'}?`}
            open={open}
            onClose={onClose}
            actionLabel="Delete"
            onAction={onDeleteChat}
            showCancel>
            <div>
                This action will permanently delete the chat, and any associated resources and memories, for all
                participants.
            </div>
        </ModalDialog>
    );
};
